import { Row } from 'react-bootstrap';

export default function NoGutterRow({ children, className = '', ...props }) {
  const nextClassName = className ? `${className} gx-0 w-100` : 'gx-0 w-100';

  return (
    <Row className={nextClassName} {...props}>
      {children}
    </Row>
  );
}
